<template>
  <div class="official-notices page-content">
    <section class="module__header">
      <h2 class="module__header__title">官方公告</h2>
      <p class="module__header__subtitle">Official Announcement</p>
    </section>
    <section class="official-notices__content">
      <section
        class="notice"
        v-for="(notice, index) in notices"
        :key="notice.id"
        :class="{
          'non-first-row': index > 1,
        }"
      >
        <section class="rich-text clear-br" v-html="notice.content"></section>
        <p class="notice__title">{{ notice.name }}</p>
      </section>
    </section>
  </div>
</template>

<script>
export default {
  name: "official-notices",
  data() {
    return {
      notices: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$get("/base/official-site/anonymous/basic-disclosure/list?type=1")
        .then((res) => {
          const data = res?.data;
          if (Array.isArray(data)) {
            this.notices = data;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style lang="less">
.official-notices {
  .official-notices__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 198px;
    box-sizing: border-box;
    .notice {
      box-sizing: border-box;
      &.non-first-row {
        margin-top: 20px;
      }
      .rich-text {
        width: 328px;
        height: 454px;
        overflow: hidden;
        img {
          width: 328px;
          height: 454px;
          object-fit: cover;
          object-position: left top;
        }
      }
      .notice__title {
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #121519;
        letter-spacing: 0;
        line-height: 26px;
        padding-top: 24px;
        text-align: center;
        box-sizing: border-box;
        // padding-right: 30px;
      }
    }
  }
}
@media all and (max-width: 1200px) {
  .official-notices {
    .official-notices__content {
      padding: 0 15px;
      box-sizing: border-box;
      .notice {
        width: 100%;
        &.non-first-row {
          padding: 0;
          margin: 0;
        }
        .rich-text {
          width: 100%;
          height: auto;
          img {
            width: 100%;
            height: auto;
            object-fit: contain;
          }
        }
      }
      .notice + .notice {
        margin-top: 20px;
      }
    }
  }
}
</style>
